import { OrderMinxin } from "@/views/mechanism/components/myDealChild/sonOrderMinxin";
import OrderApi from "@/components/Api/order";

export const Loading = {
  data() {
    return {
      animation:
        "@keyframes progress {\n" +
        "    0% {\n" +
        "        transform: rotate(0deg);\n" +
        "    }\n" +
        "    50% {\n" +
        "        transform: rotate(180deg);\n" +
        "    }\n" +
        "    100% {\n" +
        "        transform: rotate(360deg);\n" +
        "    }\n" +
        "}",
      myHtmlElement: "",
      isBody: false,
    };
  },
  methods: {
    // 通过document 创建一个加载动画页面
    createLoading(initMap) {
      initMap = {
        // 加载图标
        icon: initMap.icon ? initMap.icon : require("@/assets/png/loading.png"),
        // 是否开启默认动画,默认开启
        isAnimation:
          typeof initMap.isAnimation !== "undefined"
            ? initMap.isAnimation
            : true,
        // 遮罩层颜色 注意 只能是 rgba 的方式 不然会全遮挡
        background: initMap.background
          ? initMap.background
          : "rgba(255,255,255,0.9)",
        // 加载文字描述
        innerText: initMap.innerText ? initMap.innerText : "加载中...",
        // 加载文字颜色
        innerTextColor: initMap.innerTextColor
          ? initMap.innerTextColor
          : "black",
        // 是否挂载在body上,默认不挂载；挂载到body全屏显示,反之 只在特定块显示
        isBody: typeof initMap.isBody !== "undefined" ? initMap.isBody : false,
        // 是否需要遮罩层，默认开启
        isMask: typeof initMap.isMask !== "undefined" ? initMap.isMask : true,
        content: initMap.content,
        isButton: initMap.isButton,
      };
      this.isBody = initMap.isBody;
      var htmlElement = document.createElement("div");
      htmlElement.style.position = "absolute";
      htmlElement.style.left = "0px";
      htmlElement.style.right = "0px";
      htmlElement.style.top = "0px";
      htmlElement.style.bottom = "0px";
      if (initMap.isMask) {
        htmlElement.style.backgroundColor = initMap.background;
        htmlElement.style.zIndex = "9900";
      } else {
        htmlElement.style.zIndex = "0";
        htmlElement.style.pointerEvents = "none";
      }
      htmlElement.style.display = "flex";
      htmlElement.style.justifyContent = "center";
      htmlElement.style.alignItems = "center";
      htmlElement.style.flexDirection = "column";
      console.log("wintacLoading", this.$refs.wintacLoading);
      if (initMap.isBody) {
        document.body.appendChild(htmlElement);
      } else {
        this.$refs.wintacLoading.style.position = "relative";
        this.$refs.wintacLoading.appendChild(htmlElement);
      }
      this.myHtmlElement = htmlElement;

      var htmlStyleElement = document.createElement("style");
      htmlStyleElement.innerHTML = this.animation;

      var htmlImageElement = document.createElement("img");
      htmlImageElement.setAttribute("src", initMap.icon);
      htmlImageElement.setAttribute("class", "LoadingImg");
      htmlImageElement.style.height = "2.5vh";
      htmlImageElement.style.width = "2.5vh";
      htmlImageElement.style.zIndex = "9999";
      if (initMap.isAnimation) {
        htmlImageElement.style.animationName = "progress";
        htmlImageElement.style.animationTimingFunction = "linear";
        htmlImageElement.style.animationDelay = "0s";
        htmlImageElement.style.animationIterationCount = "infinite";
        htmlImageElement.style.animationDuration = "0.8s";
      }
      htmlImageElement.appendChild(htmlStyleElement);

      var htmlParagraphElement = document.createElement("p");
      htmlParagraphElement.innerHTML = initMap.innerText;
      htmlParagraphElement.style.fontSize = "0.5vh";
      htmlParagraphElement.style.marginTop = "10px";
      htmlParagraphElement.style.color = initMap.innerTextColor;
      htmlParagraphElement.style.fontWeight = "700";
      htmlElement.appendChild(htmlImageElement);
      htmlElement.appendChild(htmlParagraphElement);
      console.log("ksjfkjskdjfksjdkf", initMap.content);
      if (typeof initMap.content !== "undefined" && initMap.content !== "") {
        if (!initMap.isButton) {
          var htmlButtonElement = document.createElement("button");
          htmlButtonElement.setAttribute("type", "primary");
          htmlButtonElement.style.fontSize = "12px";
          htmlButtonElement.style.padding = "4px";
          htmlButtonElement.style.paddingLeft = "10px";
          htmlButtonElement.style.paddingRight = "10px";
          htmlButtonElement.style.borderRadius = "4px";
          htmlButtonElement.style.borderRadius = "4px";
          htmlButtonElement.style.background = "rgb(222, 86, 44)";
          htmlButtonElement.style.border = "none";
          htmlButtonElement.style.color = "white";
          htmlButtonElement.innerText = "取消订单";
          htmlButtonElement.onclick = () => {
            this.$confirm("您是否取消订单?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                new OrderApi("order")
                  .orderUnpaidCancellation(this.orderChildrenId)
                  .then((res) => {
                    if (res.status == 200) {
                      this.$message({
                        type: "success",
                        message: "已成功取消订单!",
                      });
                    }
                  });
              })
              .catch(() => {});
          };
          htmlElement.appendChild(htmlButtonElement);
        }
        htmlImageElement.onmouseover = function () {
          var mouseover = document.createElement("p");
          mouseover.setAttribute("id", "mouseover");
          mouseover.innerText = initMap.content;
          mouseover.style.border = "1px black solid";
          mouseover.style.padding = "2px";
          mouseover.style.paddingLeft = "8px";
          mouseover.style.paddingRight = "8px";
          mouseover.style.borderRadius = "5px";
          mouseover.style.backgroundColor = "white";
          mouseover.style.position = "absolute";
          mouseover.style.top = "1px";
          htmlElement.appendChild(mouseover);
          var htmlDivElement = document.createElement("div");
          htmlDivElement.setAttribute("id", "mouseoverDiv");
          htmlDivElement.style.height = "8px";
          htmlDivElement.style.width = "8px";
          htmlDivElement.style.backgroundColor = "white";
          htmlDivElement.style.position = "absolute";
          htmlDivElement.style.left = "50%";
          htmlDivElement.style.top = "87.5%";
          htmlDivElement.style.borderBottom = "1px solid black";
          htmlDivElement.style.borderRight = "1px solid black";
          htmlDivElement.style.transform = "translateX(-50%) rotate(45deg)";
          mouseover.appendChild(htmlDivElement);
        };
        htmlImageElement.onmouseout = function () {
          var mouseoverDoc = document.getElementById("mouseover");
          document.getElementById("mouseoverDiv").remove();
          mouseoverDoc.remove();
        };
      }
    },
    closeLoading() {
      if (this.myHtmlElement !== "") {
        if (this.isBody) {
          document.body.removeChild(this.myHtmlElement);
        } else {
          this.$refs.wintacLoading.removeChild(this.myHtmlElement);
        }
        this.myHtmlElement = "";
      }
    },
  },
};
